import '../../monitoring/filters/generic_user/applied_generic_user_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.AppliedGenericUserView extends Monitoring.Views.SocialContents.Filters.AppliedGenericUserView
  _triggerQueryChanged: => @searchQuery.triggerFilterChanged()
